import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropTypes } from "prop-types";
import React, { useRef, useState } from "react";
import AutosuggestInput from "~/components/forms/AutosuggestInput";
import ErrorMessage from "~/components/forms/ErrorMessage";
import APIRequest from "~/lib/api_request";

const LabelingForm = ({ leadID, onLabelCreated = () => undefined }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [label, setLabel] = useState({
    id: null,
    name: "",
  });

  const autosuggestRef = useRef(null);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setErrors({});

    try {
      const { body: response } = await new Promise((resolve, reject) => {
        const request = APIRequest.post({
          resource: `/v1/leads/${leadID}/labels`,
          data: { label },
        });

        request.end((error, apiResponse) => {
          if (error) {
            reject(error);
            return;
          }
          resolve(apiResponse);
        });
      });

      onLabelCreated?.(response);
      setLabel({ id: null, name: "" });

      if (autosuggestRef.current) {
        autosuggestRef.current.clear();
      }
    } catch (error) {
      console.error("Error creating label:", error);
      setErrors(
        error.response?.body?.errors || { name: "Failed to create label" },
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleLabelSelect = (option) => {
    setLabel({
      id: option.id,
      name: option.name,
    });

    if (errors) {
      setErrors({});
    }
  };

  const handleNameChange = (value) => {
    const trimmedValue = value.trim();
    setLabel({
      id: null,
      name: trimmedValue,
    });
    if (errors) {
      setErrors({});
    }
  };

  const error = errors.name || errors.label_id;

  return (
    <>
      <form
        method="POST"
        action="/labels"
        className="form-inline"
        onSubmit={handleFormSubmit}
      >
        <div className="form-group">
          <AutosuggestInput
            ref={autosuggestRef}
            placeholder="Type a Label Name"
            onSelect={handleLabelSelect}
            onInputChange={handleNameChange}
            disabled={isSubmitting}
            hasError={!!error}
          />
        </div>

        <div className="form-group mx-3">
          <button
            type={isSubmitting ? "button" : "submit"}
            className={`btn btn-primary ${isSubmitting ? "disabled" : ""}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <FontAwesomeIcon icon="far fa-spinner" pulse className="mr5" />{" "}
                Saving...
              </>
            ) : (
              "Add New Label"
            )}
          </button>
        </div>
      </form>

      {error && (
        <div>
          <ErrorMessage message={error} />
        </div>
      )}
    </>
  );
};

LabelingForm.propTypes = {
  leadID: PropTypes.number.isRequired,
  onLabelCreated: PropTypes.func,
};

export default LabelingForm;
